import { SEO } from '../components/SEO';
import { companyInfo } from '../data/content';
import { Link } from 'react-router-dom';

export function Datenschutz() {
  return (
    <>
      <SEO 
        title="Datenschutzerklärung"
        description="Datenschutzerklärung von ConciergeUnit - Informationen zum Umgang mit Ihren personenbezogenen Daten."
        path="/datenschutz"
      />

      <section className="pt-32 pb-20 bg-brand-950">
        <div className="container-custom">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white">Datenschutzerklärung</h1>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-4xl">
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-700 mb-8">
                Wir freuen uns über Ihr Interesse an unserem Unternehmen. Der Schutz Ihrer Privatsphäre 
                ist für uns sehr wichtig. Nachfolgend informieren wir Sie ausführlich über den Umgang 
                mit Ihren Daten.
              </p>

              <h2 className="text-2xl font-bold text-brand-950 mb-4 mt-12">
                1. Verantwortlicher
              </h2>
              <div className="bg-platin-50 rounded-xl p-6 mb-8 border-l-4 border-brand-950">
                <p className="font-semibold text-brand-950">{companyInfo.name}</p>
                <p className="text-gray-700">Inhaber: {companyInfo.owner}</p>
                <div className="mt-4 text-gray-700">
                  <p>{companyInfo.address.street}</p>
                  <p>{companyInfo.address.zip} {companyInfo.address.city}</p>
                  <p>{companyInfo.address.country}</p>
                </div>
                <p className="mt-4">
                  <strong>Telefon:</strong> {companyInfo.phone}<br />
                  <strong>E-Mail:</strong> {companyInfo.email}
                </p>
              </div>

              <h2 className="text-2xl font-bold text-brand-950 mb-4 mt-12">
                2. Erhebung und Speicherung personenbezogener Daten sowie Art und Zweck von deren Verwendung
              </h2>

              <h3 className="text-xl font-semibold text-brand-950 mb-3 mt-8">
                a) Beim Besuch der Website
              </h3>
              <p className="text-gray-700 mb-4">
                Beim Aufrufen unserer Website werden durch den auf Ihrem Endgerät zum Einsatz kommenden 
                Browser automatisch Informationen an den Server unserer Website gesendet. Diese 
                Informationen werden temporär in einem sogenannten Logfile gespeichert. Folgende 
                Informationen werden dabei ohne Ihr Zutun erfasst und bis zur automatisierten Löschung 
                gespeichert:
              </p>
              <ul className="list-disc list-inside text-gray-700 mb-4 space-y-1">
                <li>IP-Adresse des anfragenden Rechners</li>
                <li>Datum und Uhrzeit des Zugriffs</li>
                <li>Name und URL der abgerufenen Datei</li>
                <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
                <li>Verwendeter Browser und ggf. das Betriebssystem Ihres Rechners</li>
              </ul>
              <p className="text-gray-700 mb-6">
                Die genannten Daten werden durch uns zu folgenden Zwecken verarbeitet:
              </p>
              <ul className="list-disc list-inside text-gray-700 mb-6 space-y-1">
                <li>Gewährleistung eines reibungslosen Verbindungsaufbaus der Website</li>
                <li>Gewährleistung einer komfortablen Nutzung unserer Website</li>
                <li>Auswertung der Systemsicherheit und -stabilität</li>
              </ul>
              <p className="text-gray-700 mb-8">
                Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 S. 1 lit. f DSGVO. 
                Unser berechtigtes Interesse folgt aus oben aufgelisteten Zwecken zur Datenerhebung. 
                In keinem Fall verwenden wir die erhobenen Daten zu dem Zweck, Rückschlüsse auf 
                Ihre Person zu ziehen.
              </p>

              <h3 className="text-xl font-semibold text-brand-950 mb-3 mt-8">
                b) Bei Nutzung unseres Kontaktformulars
              </h3>
              <p className="text-gray-700 mb-4">
                Bei Fragen jeglicher Art bieten wir Ihnen die Möglichkeit, mit uns über ein auf 
                der Website bereitgestelltes Formular Kontakt aufzunehmen. Dabei ist die Angabe 
                Ihres Namens und einer gültigen E-Mail-Adresse erforderlich, damit wir wissen, 
                von wem die Anfrage stammt und um diese beantworten zu können. Weitere Angaben 
                können freiwillig getätigt werden.
              </p>
              <p className="text-gray-700 mb-6">
                Die Datenverarbeitung zum Zwecke der Kontaktaufnahme mit uns erfolgt nach 
                Art. 6 Abs. 1 S. 1 lit. a DSGVO auf Grundlage Ihrer freiwillig erteilten Einwilligung.
              </p>
              <p className="text-gray-700 mb-8">
                Die für die Benutzung des Kontaktformulars von uns erhobenen personenbezogenen 
                Daten werden nach Erledigung der von Ihnen gestellten Anfrage automatisch gelöscht, 
                sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
              </p>

              <h3 className="text-xl font-semibold text-brand-950 mb-3 mt-8">
                c) Bei Bewerbungen
              </h3>
              <p className="text-gray-700 mb-4">
                Wenn Sie sich bei uns bewerben, verarbeiten wir Ihre personenbezogenen Daten 
                (z.B. Name, Kontaktdaten, Qualifikationen) zum Zweck der Durchführung des 
                Bewerbungsverfahrens. Rechtsgrundlage ist Art. 6 Abs. 1 S. 1 lit. b DSGVO 
                (vorvertragliche Maßnahmen) und ggf. Art. 6 Abs. 1 S. 1 lit. a DSGVO (Einwilligung).
              </p>
              <p className="text-gray-700 mb-8">
                Bewerbungsdaten werden bei erfolgloser Bewerbung 6 Monate nach Abschluss des 
                Verfahrens gelöscht, sofern keine Einwilligung zur längeren Speicherung vorliegt 
                oder gesetzliche Aufbewahrungspflichten bestehen.
              </p>

              <h2 className="text-2xl font-bold text-brand-950 mb-4 mt-12">
                3. Weitergabe von Daten
              </h2>
              <p className="text-gray-700 mb-4">
                Eine Übermittlung Ihrer persönlichen Daten an Dritte zu anderen als den im 
                Folgenden aufgeführten Zwecken findet nicht statt. Wir geben Ihre persönlichen 
                Daten nur an Dritte weiter, wenn:
              </p>
              <ul className="list-disc list-inside text-gray-700 mb-8 space-y-1">
                <li>Sie Ihre ausdrückliche Einwilligung dazu erteilt haben (Art. 6 Abs. 1 S. 1 lit. a DSGVO)</li>
                <li>die Weitergabe gesetzlich zulässig und für die Abwicklung von Vertragsverhältnissen mit Ihnen erforderlich ist (Art. 6 Abs. 1 S. 1 lit. b DSGVO)</li>
                <li>für die Weitergabe eine gesetzliche Verpflichtung besteht (Art. 6 Abs. 1 S. 1 lit. c DSGVO)</li>
                <li>die Weitergabe zur Wahrung berechtigter Interessen erforderlich ist (Art. 6 Abs. 1 S. 1 lit. f DSGVO)</li>
              </ul>

              <h2 className="text-2xl font-bold text-brand-950 mb-4 mt-12">
                4. Auftragsverarbeiter
              </h2>
              <p className="text-gray-700 mb-4">
                Wir setzen zur Erbringung unserer Dienstleistungen folgende Auftragsverarbeiter ein:
              </p>
              
              <div className="bg-platin-50 rounded-xl p-6 mb-8">
                <h4 className="font-semibold text-brand-950 mb-3">Web3Forms</h4>
                <p className="text-gray-700 mb-2">
                  Zur Verarbeitung von Kontaktformularen und Bewerbungen nutzen wir den Dienst Web3Forms. 
                  Dieser verarbeitet die übermittelten Daten ausschließlich zur Zustellung an uns.
                </p>
                <p className="text-gray-700 mb-2">
                  <strong>Anbieter:</strong> Web3Forms<br />
                  <strong>Website:</strong>{' '}
                  <a 
                    href="https://web3forms.com/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-brand-600 hover:underline"
                  >
                    https://web3forms.com/
                  </a>
                </p>
                <p className="text-gray-700">
                  Es besteht ein Auftragsverarbeitungsvertrag (AVV) gemäß Art. 28 DSGVO.
                </p>
              </div>

              <div className="bg-platin-50 rounded-xl p-6 mb-8">
                <h4 className="font-semibold text-brand-950 mb-3">Netlify</h4>
                <p className="text-gray-700 mb-2">
                  Unser Website-Hosting erfolgt über Netlify. Dieser Dienstleister verarbeitet 
                  technische Daten (z.B. IP-Adressen, Zugriffszeiten) zur Bereitstellung der Website.
                </p>
                <p className="text-gray-700 mb-2">
                  <strong>Anbieter:</strong> Netlify, Inc.<br />
                  <strong>Sitz:</strong> San Francisco, USA<br />
                  <strong>Privacy Policy:</strong>{' '}
                  <a 
                    href="https://www.netlify.com/privacy/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-brand-600 hover:underline"
                  >
                    https://www.netlify.com/privacy/
                  </a>
                </p>
                <p className="text-gray-700">
                  Netlify ist unter dem EU-US Data Privacy Framework zertifiziert. 
                  Zusätzlich besteht ein Auftragsverarbeitungsvertrag (AVV).
                </p>
              </div>

              <h2 className="text-2xl font-bold text-brand-950 mb-4 mt-12">
                5. Cookies und Consent-Management
              </h2>
              <p className="text-gray-700 mb-4">
                Unsere Website verwendet Cookies. Cookies sind kleine Textdateien, die auf Ihrem 
                Endgerät gespeichert werden. Einige Cookies sind technisch notwendig, während 
                andere der Analyse oder Marketing dienen.
              </p>
              <p className="text-gray-700 mb-6">
                Bei Ihrem ersten Besuch werden Sie über unser Cookie-Banner um Ihre Einwilligung 
                gebeten. Sie können Ihre Einstellungen jederzeit ändern:
              </p>
              <div className="mb-8">
                <Link 
                  to="/?cookie-settings=true" 
                  className="inline-flex items-center gap-2 text-brand-600 hover:text-brand-800 font-medium"
                >
                  Cookie-Einstellungen öffnen
                </Link>
              </div>

              <h2 className="text-2xl font-bold text-brand-950 mb-4 mt-12">
                6. Ihre Rechte
              </h2>
              <p className="text-gray-700 mb-4">
                Sie haben das Recht:
              </p>
              <ul className="list-disc list-inside text-gray-700 mb-8 space-y-2">
                <li>gemäß Art. 15 DSGVO Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten zu verlangen</li>
                <li>gemäß Art. 16 DSGVO unverzüglich die Berichtigung unrichtiger oder Vervollständigung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen</li>
                <li>gemäß Art. 17 DSGVO die Löschung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen</li>
                <li>gemäß Art. 18 DSGVO die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen</li>
                <li>gemäß Art. 20 DSGVO Ihre personenbezogenen Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten oder die Übermittlung an einen anderen Verantwortlichen zu verlangen</li>
                <li>gemäß Art. 7 Abs. 3 DSGVO Ihre einmal erteilte Einwilligung jederzeit gegenüber uns zu widerrufen</li>
                <li>gemäß Art. 77 DSGVO sich bei einer Aufsichtsbehörde zu beschweren</li>
              </ul>

              <h2 className="text-2xl font-bold text-brand-950 mb-4 mt-12">
                7. Widerspruchsrecht
              </h2>
              <p className="text-gray-700 mb-8">
                Sofern Ihre personenbezogenen Daten auf Grundlage von berechtigten Interessen gemäß 
                Art. 6 Abs. 1 S. 1 lit. f DSGVO verarbeitet werden, haben Sie das Recht, gemäß 
                Art. 21 DSGVO Widerspruch gegen die Verarbeitung einzulegen. Möchten Sie von Ihrem 
                Widerspruchsrecht Gebrauch machen, genügt eine E-Mail an {companyInfo.email}.
              </p>

              <h2 className="text-2xl font-bold text-brand-950 mb-4 mt-12">
                8. Datensicherheit
              </h2>
              <p className="text-gray-700 mb-8">
                Wir verwenden innerhalb des Website-Besuchs das verbreitete SSL-Verfahren (Secure 
                Socket Layer) in Verbindung mit der jeweils höchsten Verschlüsselungsstufe, die 
                von Ihrem Browser unterstützt wird. Ob eine einzelne Seite unseres Internetauftritts 
                verschlüsselt übertragen wird, erkennen Sie an der Darstellung des Schloss-Symbols 
                in der Adresszeile Ihres Browsers.
              </p>

              <h2 className="text-2xl font-bold text-brand-950 mb-4 mt-12">
                9. Aktualität und Änderung dieser Datenschutzerklärung
              </h2>
              <p className="text-gray-700 mb-8">
                Diese Datenschutzerklärung ist aktuell gültig und hat den Stand Februar 2026. 
                Durch die Weiterentwicklung unserer Website und Angebote darüber oder aufgrund 
                geänderter gesetzlicher beziehungsweise behördlicher Vorgaben kann es notwendig 
                werden, diese Datenschutzerklärung zu ändern. Die jeweils aktuelle 
                Datenschutzerklärung kann jederzeit auf der Website unter{' '}
                <Link to="/datenschutz" className="text-brand-600 hover:underline">
                  /datenschutz
                </Link>{' '}
                von Ihnen abgerufen und ausgedruckt werden.
              </p>

              <div className="mt-16 p-6 bg-brand-50 border border-brand-200 rounded-xl">
                <h3 className="font-semibold text-brand-950 mb-2">
                  Kontakt zum Datenschutz
                </h3>
                <p className="text-brand-700">
                  Bei Fragen zum Datenschutz erreichen Sie uns unter{' '}
                  <a href={`mailto:${companyInfo.email}`} className="underline">
                    {companyInfo.email}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
